<template>
  <Grid
    :fstyle="{
      justifyContent: 'space-evenly',
      flexDirection: 'column',
      height: '100%',
      alignItems: 'center',
    }"
  >
    <template v-for="(chip, idx) in poleState">
      <div
        :style="
          chip.active
            ? formatColor(chip.colorActive, chip.bgActive)
            : formatColor(chip.color, chip.bg)
        "
        @click="dispatch({ type: 'chip', idx })"
        :class="
          chip.active
            ? 'Chip Active ' + chip.className
            : 'Chip ' + chip.className
        "
        :key="idx"
      >
        <Indicator :state="chip" />
        <div class="Text">
          {{ $t(chip.text) }}
        </div>
      </div>
    </template>
  </Grid>
</template>

<script>
import Indicator from './Indicator.vue';
import Grid from '../../shared/Grid.vue';

export default {
  props: ['poleState', 'dispatch'],
  components: { Indicator, Grid },
  data() {
    return {
      style: null,
      activeStyle: null,
      classnames: null,
    };
  },
  methods: {
    formatColor(color, bg) {
      return {
        '--chip-f-color': color,
        '--chip-active-bg': bg,
        '--chip-border-color': color,
      };
    },
    classNames(obj) {
      return Object.entries(obj)
        .filter(([, bool]) => bool)
        .map(([key]) => key)
        .join(' ');
    },
  },
};
</script>

<style scoped>
.Chip {
  --chip-f-size: 14px;
  display: grid;
  align-items: center;
  /* justify-content: space-evenly; */
  grid-template-columns: 1fr;
  border-radius: var(--chip-border-radius);
  font-size: var(--chip-f-size);
  color: var(--chip-f-color);
  padding: 0.5em 0.8em 0.5em 0.8em;
  text-align: center;
  cursor: pointer;
  width: max-content;
}

.Text {
  justify-self: center;
}
.Available {
  background: none;
  border: 1px solid #7dcc93;
}
.Reserved {
  background: none;
  border: 1px solid #ffdf22;
}
.Charging {
  background: none;
  border: 1px solid #2299ff;
}
.Unavailable {
  background: none;
  border: 1px solid #f15c5e;
}
.Active {
  background: var(--chip-active-bg);
  animation: chipFadeIn 0.3s linear;
}
@keyframes chipFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media (min-width: 768px) {
  .Chip {
    --chip-f-size: 12px;
    grid-template-columns: auto 1fr;
    padding: 0.3em 1.3em 0.3em 0.5em;
  }
  .Text {
    justify-self: flex-start;
    padding-left: 6px;
  }
}

@media (min-width: 1400px) {
  .Chip {
    --chip-f-size: 20px;
    padding: 0.5em 1.5em 0.5em 0.8em;
  }
  .Text {
    padding-left: 12px;
  }
}
</style>
